import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { AppProvider } from './context/AppContext';
import SwimmerList from './components/SwimmerList';
import SwimmerDetail from './components/SwimmerDetail';
import EventTimes from './components/EventTimes';
import theme from './theme';

const App = () => (
  <ThemeProvider theme={theme}>
    <AppProvider>
      <Router>
        <Routes>
          <Route path="/" element={<SwimmerList />} />
          <Route path="/swimmer/:swimmerName" element={<SwimmerDetail />} />
          <Route path="/swimmer/:swimmerName/event/:eventName" element={<EventTimes />} />
        </Routes>
      </Router>
    </AppProvider>
  </ThemeProvider>
);

export default App;